export const AdminProjectSyncController = {
    edit(): void {},
    update(): void {},
    saveApiKey(): void {},
    restoreLast(): void {},
};
